<template>
  <div>
    <b-input-group>
      <b-dropdown
        :disabled="isDisabled"
        variant="outline-secondary"
        size="sm"
        no-caret
        class="flex-grow-1 custom-scroll-menu"
        menu-class="z-index-dropdown"
        toggle-class="d-flex justify-content-between align-items-center bg-white text-dark border shadow-none"
      >
        <template #button-content>
          <span class="text-truncate mr-2" :class="selectedIds.length === 0 ? 'text-muted' : 'text-dark'">
            {{ displayText }}
          </span>
          <font-awesome-icon icon="chevron-down" size="xs" class="text-muted"/>
        </template>

        <div class="py-1 px-3">
          <filters-drawer
            :query.sync="query"
            :hideSearchButton = true
            @submit="onSearch"
            class="mb-2"
          />
          <div v-if="items.length === 0" class="text-muted text-small">
            Ничего не найдено
          </div>
        </div>

        <div class="scrollable-dropdown-content">
          <b-list-group flush class="text-small" @click.stop>
            <b-list-group-item
              v-for="option in items"
              :key="option.id"
              button
              action
              class="d-flex align-items-center justify-content-between py-2 px-3"
              @click="toggleItem(option.id)"
            >
              <span>{{ option.name }}</span>
              <font-awesome-icon v-if="selectedIds.includes(option.id)" icon="check"/>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-dropdown>

      <b-input-group-append>
        <b-button
          size="sm"
          variant="secondary"
          :disabled="selectedIds.length === 0 || isDisabled"
          @click="onClear"
        >
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
          v-if="canCreateCatalog()"
          size="sm"
          variant="success"
          :disabled="isDisabled"
          @click="showModalCatalog"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <Citizenship
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCitizenshipCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Citizenship from "./Citizenship.vue";
import FiltersDrawer from "../../../utilites/commonUi/FiltersDrawer";
import pageSearchService from "../../../utilites/pageSearchService";

export default {
  name: "CitizenshipsMultiSelect",
  components: { Citizenship, FiltersDrawer },
  mixins: [
    catalogs,
    permissions,
    pageSearchService
  ],
  props: {
    isDisabled: Boolean,
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      query: "",
      items: [],
      selectedIds: [],
      isModalVisible: false,
      disableRouting: true,
    };
  },
  async created() {
    await this.getItems();
  },
  methods: {
    async getItems() {
      const result = await this.getCitizenshipsSearch(this.query);
      if (result.data != null) {
        this.items = result.data;
      }
    },
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS_EDIT]);
    },
    onSelectionChange(checkedIds) {
      this.$emit('input', checkedIds);
      this.$emit('onSelect', checkedIds);
    },
    onClear() {
      this.selectedIds = [];
      this.onSelectionChange([]);
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onCitizenshipCreated(newItem) {
      this.$emit('catalog-created', newItem);
      this.isModalVisible = false;
      await this.getItems();

      if (newItem && newItem.id) {
        this.selectedIds.push(newItem.id);
        this.onSelectionChange(this.selectedIds);
      }
    },
    toggleItem(id) {
      const index = this.selectedIds.indexOf(id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      } else {
        this.selectedIds.push(id);
      }
      this.onSelectionChange(this.selectedIds);
    }
  },
  computed: {
    displayText() {
      if (this.selectedIds.length === 0) return "Выберите из списка";

      const selectedNames = this.items
        .filter(i => this.selectedIds.includes(i.id))
        .map(i => i.name);

      if (selectedNames.length <= 3) return selectedNames.join(", ");

      return `Выбрано: ${selectedNames.length}`;
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.selectedIds = [...newValue];
      }, immediate: true
    },
  },
};
</script>

<style scoped>
.scrollable-dropdown-content {
  max-height: 200px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Citizenships/CitizenshipsMultiSelect.vue